import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, DateRangePickerField, BaasicFormControls, DateRangeQueryPicker, QueryDropdown } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';

function ScheduleListTemplate({ listViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        generateForm,
        rangeQueryPickerStore,
        facilityStore,
        authorization
    } = listViewStore;

    return (
        <ApplicationListLayout store={listViewStore}>
            <PageNavigation>
                <div className="daterange__wrap">
                    <div className="daterange__input">
                        <DateRangePickerField fromField={generateForm.$('startDate')} toField={generateForm.$('endDate')} />
                    </div>
                    <div className="daterange__button">
                        <BaasicFormControls form={generateForm} onSubmit={generateForm.onSubmit} disabled={tableStore.loading} label="Generate Dates" />
                    </div>
                </div>
            </PageNavigation>
            <Content  emptyRenderer={renderEmpty()}>
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} showSearchFilter={false}>
                        <div className="col col-sml-12 col-med-6 col-lrg-8 col-xxlrg-4">
                            <DateRangeQueryPicker queryUtility={queryUtility} fromPropertyName="dateFrom" toPropertyName="dateTo" store={rangeQueryPickerStore} timeZone="UTC" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2">
                            <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility" />
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='SCHEDULE.LIST.EMPTY_STATE.TITLE' description='SCHEDULE.LIST.EMPTY_STATE.DESCRIPTION' />
}

ScheduleListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

export default defaultTemplate(ScheduleListTemplate);
